<template>
  <section class="privateWallet">
    <div class="privateWallet-con">
      <div class="text"><title-desc-tutorial :title="$t('overview.telegramChat.title')" :descList="descList" :videoList="videoList" :theme="'theme_chat'"></title-desc-tutorial></div>
      <div class="privateWallet-img">
        <div class="imgbox">
          <div class="phone">
            <img class="img1" src="../../assets/img/Mockup_8.png" />
            <img class="button" src="../../assets/img/Mockup_8_2.png" />
          </div>
          <img class="gold gold-left" :class="{ move:anime }" src="../../assets/img/pic_coin_left.svg">
          <img class="gold gold-right" :class="{ move:anime }" src="../../assets/img/pic_coin_right.svg">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import TitleDescTutorial from '../../components/common/title-desc-tutorial'

export default {
  components: {
    TitleDescTutorial
  },
  data() {
    return {
      descList: [
        this.$t('overview.telegramChat.list1'),
        this.$t('overview.telegramChat.list2')
      ],
      videoList: [
        {
          title: this.$t('overview.telegramChat.tutorial1'),
          url: 'https://www.youtube.com/watch?v=xgJowIWxVC0'
        },
        {
          title: this.$t('overview.telegramChat.tutorial2'),
          url: 'https://www.youtube.com/watch?v=KtewC-XmnVw'
        },
        {
          title: this.$t('overview.telegramChat.tutorial3'),
          url: 'https://www.youtube.com/watch?v=MZIJ160_X-s'
        }
      ],
      imgNum: 0,
      imgElNum: 0,
      anime: false
    }
  },
  methods: {
    computImg () {
      this.imgNum += 1
      if (this.imgElNum === 0) {
        return false
      }
      if (this.imgNum === this.imgElNum) {
        this.mountAnime()
      }
    },
    mountAnime () {
      window.sr.reveal('.gold', {
        viewFactor: .3,
        scale: 1,
        duration: 0,
        origin: 'left',
        distance: '0',
        easing: 'ease-out',
        opacity: 1,
        delay: 500,
        afterReveal: () => {
          this.anime = true
        },
      })
    }
  },
  mounted () {
    let imgs = this.$el.getElementsByTagName('img')
    this.imgElNum = imgs.length
    for (let i = 0; i < imgs.length; i++) {
      let src = imgs[i].src
      imgs[i].src = ''
      imgs[i].addEventListener('load', () => {
        this.computImg()
      })
      imgs[i].src = src
    }
  }
}
</script>

<style lang="css" scoped>
.privateWallet {
  background-image: url("../../assets/img/pic_gradiernt_bg.jpg");
  background-size: cover;
}
.privateWallet-con {
  max-width: 1200px;
  margin: auto;
  padding: 87px 20px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.privateWallet-img {
  width: auto;
  max-width: 514px;
  display: flex;
  justify-content: flex-end;
  align-self: flex-end;
  align-items: flex-end;
  flex: 1;
}
.text {
  max-width: 450px;
  width: auto;
  padding: 215px 0 230px;
}

.phone {
  position: relative;
}

.phone .button {
  position: absolute;
  left: 0;
  bottom: 0;
}

.privateWallet-img .imgbox {
  max-width: 488px;
  width: auto;
  font-size: 0;
  position: relative;
}

.gold-left {
  max-width: 111px;
  position: absolute;
  left: -7px;
  top: 29%;
  transform: translate3d(128%, 128%, 0);
  transition: all .6s ease-out;
}
.gold-right {
  max-width: 126px;
  position: absolute;
  right: -20px;
  top: 8%;
  transform: translate3d(-128%, 259%, 0);
  transition: all .6s ease-out;
}

.move {
  transform: translate3d(0, 0, 0);
}

.privateWallet-img img {
  width: 100%;
}

@media screen and (max-width: 768px) {
  .privateWallet-con {
    display: block;
    padding: 56px 20px 10px;
  }
  .text {
    max-width: 100%;
    padding: 0px;
    margin-top: -1px;
  }
  .privateWallet-img {
    margin: auto;
    justify-content: center;
  }
  .privateWallet .title-desc-tutorial .desc {
    background: #000 !important;
  }
}
</style>